import React, { useEffect, useState } from "react";
import { LinearProgress, useDataProvider, useRecordContext } from "react-admin";

type Props = {
  sortable?: boolean;
  source?: string;
};

export const SpotContractStoragePeriodsField: React.FC<Props> = () => {
  const record = useRecordContext();

  const dataProvider = useDataProvider();
  const [isLoading, setIsLoading] = useState(false);
  const [maxDays, setMaxDays] = useState(0);

  let ids: number[] = [];
  if (record !== undefined) {
    ids = record.storage_period_ids;
  }

  useEffect(() => {
    let isCleanedUp = false;

    (async () => {
      if (!isCleanedUp) {
        setIsLoading(true);
      }

      const promises = ids.map((id) => {
        return dataProvider.getOne("spot_contract_storage_periods", { id });
      });
      const results = await Promise.all(promises);

      if (!isCleanedUp) {
        // fetchに失敗すると結果がundefeindになるため
        if (results) {
          const periods = results.filter((res) => res).map((res: any) => res.data);

          const calculatedMaxDays = periods
            .filter((sp) => ids.includes(sp.id))
            .reduce((value: number, sp) => {
              const { storage_period_in_days } = sp;
              return storage_period_in_days > value ? storage_period_in_days : value;
            }, 0);
          setMaxDays(calculatedMaxDays);
        }

        setIsLoading(false);
      }
    })();

    return () => {
      isCleanedUp = true;
    };
  }, [dataProvider, ids]);

  if (isLoading) {
    return <LinearProgress />;
  }

  return <span>最大{maxDays}日</span>;
};
